import React from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";

const LaunchingSoon = () => {
  return (
    <>
    <Helmet>
      <title>eYantra Blogs on Corporate Gifting</title>
      <meta name="description" content="Read eYantra blogs on employee gifts, personalised business items, joining kits, and onboarding kits to explore smart corporate gifting solutions."/>
      <meta name="keywords" content="eyantra, blogs, corporate gifting, joining kits, rewards and recognitions, onboarding kits for employees, corporate gifts for employees, welcome kits, employee gifts, personalised business items"/>
    </Helmet>
      <div className="container-fluid vh-100 d-flex justify-content-center align-items-center bg-light">
        <Container>
          <div className="text-center">
            <h2 className="texteYantra py-3 fs-48">Launching Soon....</h2>
            <Link to="/" className="text-decoration-none" id="btnCTA">
              Go back to Home
            </Link>
          </div>
        </Container>
      </div>
    </>
  );
};

export default LaunchingSoon;
